module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Warnet Life - Racikan Penyihir","short_name":"Warnet Life - Racikan Penyihir","start_url":"/","background_color":"#4c3957","theme_color":"#50485b","display":"standalone","icon":"src/favicons/favicon.png","icons":[{"src":"src/favicons/favicon-192.png","sizes":"192x192","type":"image/png"},{"src":"src/favicons/favicon-512.png","sizes":"512x512","type":"image/png"}],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"95c584e95ab4dc1d50bfe526defce09d"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
